import RepositoryFactory from '@/repository/RepositoryFactory';

const FEATURE_KEY = 'useContactToScheduleApplyRollout';

// ロールアウトフラグ useContactToScheduleApplyRollout が全施設に公開済みかを判定する。
export const isContactToScheduleApplyRolloutPublic = async (): Promise<boolean> => {
  try {
    const response = await RepositoryFactory.manager.betaFeatureRollout.get(FEATURE_KEY);
    return response.data.data.isFullyRolledOut;
  } catch {
    return false;
  }
};
